import { ApolloError, NetworkStatus } from '@apollo/client';
import Bugsnag from '@bugsnag/js';
import type {
    ApolloClient,
    ApolloQueryResult,
    NormalizedCacheObject,
    QueryOptions,
    ServerParseError,
} from '@apollo/client';
import type { NotifiableError } from '@bugsnag/js';

/**
 * Executes GraphQL query and handles any thrown errors avoiding app crashing
 */
export async function handleQuery<Q>(
    client: ApolloClient<NormalizedCacheObject>,
    queryOptions: QueryOptions,
    context?: string
): Promise<ApolloQueryResult<Q>> {
    try {
        const response = await client.query(queryOptions);

        if (response.error) {
            if (context) {
                Bugsnag.notify(response.error, (event) => {
                    event.context = context;
                });
            } else {
                Bugsnag.notify(response.error);
            }
        }

        return response;
    } catch (error) {
        if (error instanceof ApolloError && error.networkError) {
            Bugsnag.notify(error, (event) => {
                event.context = ((error as ApolloError).networkError as ServerParseError).bodyText;
            });
        } else {
            Bugsnag.notify(error as NotifiableError);
        }

        return {
            error: error as ApolloError,
            data: null as unknown as Q,
            loading: false,
            networkStatus: NetworkStatus.error,
        };
    }
}
